import Swal from "sweetalert2";

export const Popup = ({
  title,
  text,
  icon,
  confirmButtonText,
  onConfirm,
  cancelButtonText,
  onCancel,
}) => {
  Swal.fire({
    title: title || "Default Title",
    text: text || "Default Text",
    icon: icon || "info",
    confirmButtonText: confirmButtonText || "OK",
    showCancelButton: !!cancelButtonText, // Show cancel button if provided
    cancelButtonText: cancelButtonText || "Cancel",
    customClass: {
      confirmButton: "btn button-primary",
      cancelButton: "btn button-secondary",
    },
  }).then((result) => {
    if (result.isConfirmed && onConfirm) {
      onConfirm(); // Call the onConfirm function if the user clicks "OK"
    } else if (result.dismiss === Swal.DismissReason.cancel && onCancel) {
      onCancel(); // Call the onCancel function if the user clicks "Cancel"
    }
  });
};
